import React, { forwardRef, useEffect, useState } from "react";
import { MdClear } from "react-icons/md";

const Select = forwardRef(
  ({
    options,
    setValue,
    isTableSelect,
    placeholder,
    isInputChild,
    initialValue,
    customW,
    canReset,
    disabled,
  }) => {
    const [selectedOp, setSelectedOp] = useState(initialValue || "");
    const [optionSelected, setOptionSelected] = useState(false);

    useEffect(() => {
      // Establecer el `selectedOp` inicial si `initialValue` existe en las `options`
      if (initialValue && options.some((op) => op.value === initialValue)) {
        setSelectedOp(initialValue);
        setOptionSelected(true);
      }
    }, [initialValue, options]);

    const changeVal = (e) => {
      const selectedValue = e.target.value;
      setSelectedOp(selectedValue);
      setValue(e);
      setOptionSelected(true);
    };

    const reset = () => {
      setSelectedOp("");
      setValue({ target: { value: "" } });
      setOptionSelected(false);
    };

    return (
      <div
        className={`${
          customW ? customW : "w-fit"
        } flex flex-row items-center bg-white px-2 h-fit 
          ${isTableSelect ? "rounded-[10px] " : "rounded-full "} 
    ${
      !isInputChild
        ? "border-[1px] border-accent-green"
        : "focus:ring-transparent  border-none outline-none"
    }`}
      >
        <select
          disabled={disabled}
          value={selectedOp}
          onChange={changeVal}
          className={`${
            !optionSelected ? "text-light-gray" : "text-dark-green"
          } flex flex-row bg-white  ${
            customW ? customW : "min-w-[150px]"
          } items-center justify-between ${
            isTableSelect
              ? "rounded-[10px] font-poppins"
              : "rounded-full font-nunito"
          } 
        focus:ring-transparent  border-none outline-none
        
      `}
        >
          <option key={0} value="" disabled>
            {placeholder ? placeholder : "Seleccionar"}
          </option>
          {options.map((op, i) => (
            <option className="text-dark-green" key={i + 1} value={op.value}>
              {op.text}
            </option>
          ))}
        </select>
        {canReset && (
          <button
            className="rounded-full bg-dark-green hover:bg-accent-green p-1 text-white"
            onClick={reset}
          >
            <MdClear />
          </button>
        )}
      </div>
    );
  }
);

export default Select;
